import React from 'react';

const SuggestionsTitle = (section) => (
  <div>{section.title}</div>
);

export default SuggestionsTitle;
